// BridgeOverlay.jsx

import { useState, useEffect } from 'react';
import { handleShare } from '../MarketingUtils/Share';


export default function BridgeOverlay() {
  const [open, setOpen] = useState(false);
  const [closed, setClosed] = useState(false);


  useEffect(() => {
    // If user has shared in this session, never show overlay until tab/window is closed
    if (sessionStorage.getItem('bridgeOverlayShared') === 'true' || closed) return;
    const handleScroll = () => {
      if (sessionStorage.getItem('bridgeOverlayShared') === 'true' || closed) return;
      const scrollTop = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = docHeight > 0 ? scrollTop / docHeight : 0;
      if (scrolled >= 0.7) {
        setOpen(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [closed]);

  const handleClose = () => {
    setOpen(false);
    setClosed(true);
  };

  const handleShareClick = () => {
    sessionStorage.setItem('bridgeOverlayShared', 'true');
    handleShare();
    setOpen(false);
    setClosed(true);
  };

  if (!open) return null;
  return (
    <div className="fixed right-0 top-1/4 bg-indigo-950 text-white w-72 p-5 rounded-l-2xl shadow-lg z-40">
      <button
        className="absolute top-2 right-3 text-indigo-200/50 hover:text-white text-2xl font-bold focus:outline-none"
        aria-label="Close"
        onClick={handleClose}
        style={{ lineHeight: 1 }}
      >
        &times;
      </button>
      <h3 className="text-xl font-bold text-indigo-50 mb-2">Be the Bridge</h3>
      <p className="text-sm opacity-90 mb-4">
        Sharing Andlegur helps extend a supportive space for reflection, balance, and personal growth.
      </p>
      <button
        className="bg-rose-500 text-indigo-50 px-3 py-2 rounded-md hover:bg-indigo-600 transition w-full"
        onClick={handleShareClick}
      >
        Share
      </button>
    </div>
  );
}
